<template>
  <div class="rules">
    <h3>Drinking Rules:</h3>
    <ul>
      <li v-for="rule in rules">{{ rule }}</li>
    </ul>
  </div>
</template>

<script>
import rules from 'json-loader!yaml-loader!../assets/drinking-rules.yaml';

export default {
  name: 'drinking-rules',
  data() {
    return {
      rules
    };
  }
};
</script>

<style scoped>
.rules {
  display: flex;
  /**align-items: center;**/
  justify-content: center;
}

li {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// DrinkingRules.vue?9374020e